import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import './Wallet.css';
import { FaWallet, FaMoneyBillWave, FaUserPlus, FaCalendarAlt, FaSearch, FaInfoCircle } from 'react-icons/fa';
import { IoMdClose } from "react-icons/io";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { IoOpenOutline } from "react-icons/io5";
import API_CONFIG from '../commonApi/ApiConfig';

const customStylesRes = {
    content: {
      position: 'absolute',
      border: '1px solid rgb(204, 204, 204)',
      background: 'rgb(255, 255, 255)',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      top: '60px',
      left: '50%',
      padding: '20px',
      transform: 'translate(-50%, 0%)',
      width: '100%',
      maxWidth: '85%',
      height: '100%',
      maxHeight: '90%',
    }
  }


const Wallet = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [MoneyAddModalIsOpen, setMoneyAddModalIsOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState('');
    const navigate = useNavigate();
    const [pageinationdata, setPageinationdata] = useState({
        
        "total": 0,
        "currentPage": 1,
        "totalPages": 0,
        "limit": 10,
        "startItem": 0,
        "endItem": 0,
        "hasNextPage": false,
        "hasPrevPage": false
    
    });
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: ''
    });

    const [moneyFormData, setMoneyFormData] = useState({
        amount: '',
        type: 'credit',
        description: '',
        expiryDate: ''
    });

    const [userList, setUserList] = useState([]);


    const getUsers = async () => {
        try {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", `Bearer ${localStorage.getItem('token')}`);
      
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
          };
      
          fetch(`${API_CONFIG.WALLET_API}/GetAllUserWithBalance?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
              console.log(result)
              if (result.success) {
                setUserList(result.data);
                setPageinationdata(result.pagination);
              } else {
                Swal.fire({
                  icon: 'error',
                  title: result.message,
                })
              }
            })
        } catch (error) {
          console.error(error);
        }
      }

    const openModal = () => {
        setModalIsOpen(true);
    };
    const openMoneyAddModal = (user) => {
        setSelectedUser(user);
        setMoneyAddModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const closeMoneyAddModal = () => {
        setMoneyAddModalIsOpen(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'phoneNumber') {
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData(prevState => ({
                ...prevState,
                [name]: numericValue
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        try {
            const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("Authorization", `Bearer ${localStorage.getItem('token')}`);

const raw = JSON.stringify({
  "name": formData.name,
  "email": formData.email,
  "mobileNo": formData.phoneNumber
});

const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch(`${API_CONFIG.WALLET_API}/AddNewUser`, requestOptions)
  .then((response) => response.json())
  .then((result) => {console.log(result)
    if (result.success) {
        Swal.fire({
            icon: 'success',
            title: result.message,
            showConfirmButton: false,
            timer: 1500
        })

        getUsers();
        
    }else{
        Swal.fire({
            icon: 'error',
            title: result.message,
            showConfirmButton: false,
            timer: 1500
        })
    }
  })
  .catch((error) => {console.error(error)
    Swal.fire({
        icon: 'error',
        title: 'Something went wrong',
        showConfirmButton: false,
        timer: 1500
    })
  });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Something went wrong',
                showConfirmButton: false,
                timer: 1500
            })
        }
        
        closeModal();
        setFormData({ name: '', email: '', phoneNumber: '' });
    };

    const handleMoneyFormChange = (e) => {
        const { name, value } = e.target;
        setMoneyFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleMoneySubmit = (e) => {
        e.preventDefault();
        console.log('Money Form submitted:', moneyFormData);
        console.log('For user:', selectedUser);
        
        try {
            const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("Authorization", `Bearer ${localStorage.getItem('token')}`);

const raw = JSON.stringify({
  "userId": selectedUser._id,
  "amount": moneyFormData.amount,
  "transactionType": moneyFormData.type,
  "message": moneyFormData.description,
  "expiryDate": moneyFormData.expiryDate
});

const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch(`${API_CONFIG.WALLET_API}/AddBalance`, requestOptions)
  .then((response) => response.json())
  .then((result) => {console.log(result)
    if (result.success) {
        Swal.fire({
            icon: 'success',
            title: result.message,
        })
        getUsers();
    }
  })
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Something went wrong',
                showConfirmButton: false,
                timer: 1500
            })
        }
        
        closeMoneyAddModal();
        setMoneyFormData({ amount: '', type: 'credit', description: '', expiryDate: '' });
    };
    const handlePageChange = (newPage) => {
        setPage(newPage);
      };

    useEffect(() => {
        getUsers();
    }, [page,limit,search]);
    
  return (

    <>
    <div className="container-fluid py-5 mt-4 wwwwwww">
    <div className="row justify-content-center">
      <div className="col-md-11">
        <div className="card shadow">
          <div className="card-header bg-gradient d-flex align-items-center justify-content-between">
            <h4 className="card-title mb-0"> <span className='mr-1'><FaWallet className="me-2" /> </span>Wallet Management</h4>
              <div className="input-group me-3 w-25">
                <span className="input-group-text"><FaSearch /></span>
                <input type="text" className="form-control" placeholder="Search users..." value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
            <div className="">
              <button className="custom-button_add_user" onClick={openModal}>
                <span className='mr-1'><FaUserPlus className="me-2" /> </span> <span>Add User</span>
              </button>
            </div>
          </div>

          <div className="card-body scrollbar-custom mt-2">
            <table className="table table-hover table-striped">
                <thead className="table-primary">
                    <tr>
                        <th className='text-center' >S.No</th>
                        <th className='text-center' >Name</th>
                        <th className='text-center' >Email</th>
                        <th className='text-center' >Phone Number</th>
                        <th className='text-center' >Balance</th>
                        <th className='text-center' >Action</th>
                    </tr>
                </thead>
                <tbody>
                    {userList.map((user, index) => (
                        <tr key={user.id}>
                            <td className='text-center' >{index + 1}</td>
                            <td className='text-center' >{user.name}</td>
                            <td className='text-center' >{user.email}</td>
                            <td className='text-center' >{user.mobileNo}</td>
                            <td className='text-center'>
                              <span className="badge bg-success p-2 px-3 rounded-pill text-white">
                              ₹{Number(user.totalCredit) - Number(user.totalDebit)}
                              </span>
                            </td>
                            <td className='text-center' >
                                <button className="btn btn-primary btn-sm d-flex align-items-center mx-auto d-flex justify-content-center align-items-center " onClick={() => openMoneyAddModal(user)}>
                                  <span className='mr-1'><FaMoneyBillWave className="me-1" /> </span> <span>Add Money</span>
                                </button>
                                <button className="btn btn-primary btn-sm mt-2 d-flex align-items-center mx-auto d-flex justify-content-center align-items-center " onClick={() => navigate(`/view-wallet/${user._id}`,{state:{amount:`₹${Number(user.totalCredit) - Number(user.totalDebit)}`}})}>
                                  <span className='mr-1'><IoOpenOutline className="me-1" /> </span> <span>View Wallet</span>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
          </div>

          <div className="card-footer d-flex justify-content-between align-items-center pt-2 bg-light px-2 pb-2">
  <div className="d-none d-md-block">
    <span className="text-muted">
      Showing {pageinationdata.startItem || 0}-{pageinationdata.endItem || 0} of {pageinationdata.total || 0} users
    </span>
  </div>
  <nav aria-label="Page navigation" className="mx-auto mx-md-0">
    <ul className="pagination pagination-sm flex-wrap mb-0">
      <li className={`page-item ${!pageinationdata.hasPrevPage ? 'disabled' : ''}`}>
        <button 
          className="page-link" 
          onClick={() => handlePageChange(1)}
          disabled={!pageinationdata.hasPrevPage}
        >
          <span aria-hidden="true">&laquo;&laquo;</span>
        </button>
      </li>
      <li className={`page-item ${!pageinationdata.hasPrevPage ? 'disabled' : ''}`}>
        <button 
          className="page-link" 
          onClick={() => handlePageChange(page - 1)}
          disabled={!pageinationdata.hasPrevPage}
        >
          <span aria-hidden="true">&laquo;</span>
        </button>
      </li>
      
      {(() => {
        const totalPages = pageinationdata.totalPages || 0;
        const pagesPerGroup = 6;
        let startPage = Math.max(1, page - Math.floor(pagesPerGroup / 2));
        let endPage = Math.min(totalPages, startPage + pagesPerGroup - 1);
        
        if (endPage - startPage + 1 < pagesPerGroup) {
          startPage = Math.max(1, endPage - pagesPerGroup + 1);
        }
        
        const pageNumbers = [];
        for (let i = startPage; i <= endPage; i++) {
          pageNumbers.push(i);
        }
        
        return pageNumbers.map(pageNum => (
          <li key={pageNum} className={`page-item ${page === pageNum ? 'active' : ''}`}>
            <button 
              className="page-link" 
              onClick={() => handlePageChange(pageNum)}
            >
              {pageNum}
            </button>
          </li>
        ));
      })()}
      
      <li className={`page-item ${!pageinationdata.hasNextPage ? 'disabled' : ''}`}>
        <button 
          className="page-link" 
          onClick={() => handlePageChange(page + 1)}
          disabled={!pageinationdata.hasNextPage}
        >
          <span aria-hidden="true">&raquo;</span>
        </button>
      </li>
      <li className={`page-item ${!pageinationdata.hasNextPage ? 'disabled' : ''}`}>
        <button 
          className="page-link" 
          onClick={() => handlePageChange(pageinationdata.totalPages || 1)}
          disabled={!pageinationdata.hasNextPage}
        >
          <span aria-hidden="true">&raquo;&raquo;</span>
        </button>
      </li>
    </ul>
  </nav>
</div>
        </div>

        </div>
        </div>
        </div>

        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Add User Modal"
            className="modal-dialog modal-dialog-centered"
            ariaHideApp={false}
        >
            <div className="modal-content shadow">
                <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title  "><FaUserPlus className="me-2" /> Add User</h5>
                    <button type="button" className="btn-close btn bg-white" onClick={closeModal}><IoMdClose />
                    </button>
                </div>
                <div className="modal-body p-4">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label fw-bold">Name</label>
                            <input 
                                type="text" 
                                className="form-control form-control-lg" 
                                id="name" 
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter full name"
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label fw-bold">Email</label>
                            <input 
                                type="email" 
                                className="form-control form-control-lg" 
                                id="email" 
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter email address"
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="phoneNumber" className="form-label fw-bold">Phone Number</label>
                            <input 
                                type="tel" 
                                className="form-control form-control-lg" 
                                id="phoneNumber" 
                                name="phoneNumber"
                                maxLength={10}
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                placeholder="Enter phone number"
                                required
                            />
                        </div>
                        <div className="d-grid gap-2 mt-4">
                            <button type="submit" className="btn btn-primary btn-lg"> <FaUserPlus className="me-2" /> Add User</button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>

        <Modal
            isOpen={MoneyAddModalIsOpen}
            onRequestClose={closeMoneyAddModal}
            contentLabel="Add Money Modal"
            className="modal-dialog modal-dialog-centered"
           
            ariaHideApp={false}
        >
            <div className="modal-content shadow">
                <div className="modal-header bg-success text-white">
                    <h5 className="modal-title"><FaMoneyBillWave className="me-2" />  Add Money to Wallet</h5>
                    <button type="button" className="btn-close btn bg-white" onClick={closeMoneyAddModal}>
                        <IoMdClose />
                    </button>
                </div>
                <div className="modal-body p-4">
                    {selectedUser && (
                        <div className="user-info mb-4 p-3 bg-light rounded">
                            <div className="d-flex justify-content-between">
                                <div className='overflow-wrap-anywhere_div'>
                                    <h5 className="mb-1">{selectedUser.name}</h5>
                                    <p className="text-muted mb-0">{selectedUser.email}</p>
                                </div>
                               
                            </div>
                        </div>
                    )}
                    <form onSubmit={handleMoneySubmit}>
                        <div className="mb-4">
                            <label htmlFor="amount" className="form-label fw-bold">Money Amount ($)</label>
                            <div className="input-group input-group-lg">
                                <span className="input-group-text">$</span>
                                <input 
                                    type="number" 
                                    className="form-control form-control-lg" 
                                    id="amount" 
                                    name="amount"
                                    value={moneyFormData.amount}
                                    onChange={handleMoneyFormChange}
                                    placeholder="Enter amount"
                                    required
                                />
                            </div>
                        </div>
                        
                        <div className="mb-4">
                            <label htmlFor="type" className="form-label fw-bold">Transaction Type</label>
                            <div className="d-flex">
                                <div className="form-check form-check-inline flex-fill">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="type"
                                        id="typeCredit"
                                        value="credit"
                                        checked={moneyFormData.type === 'credit'}
                                        onChange={handleMoneyFormChange}
                                    />
                                    <label className="form-check-label" htmlFor="typeCredit">
                                        <span className="badge bg-success p-2 px-3 text-white">Credit (Add)</span>
                                    </label>
                                </div>
                                <div className="form-check form-check-inline flex-fill">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="type"
                                        id="typeDebit"
                                        value="debit"
                                        checked={moneyFormData.type === 'debit'}
                                        onChange={handleMoneyFormChange}
                                    />
                                    <label className="form-check-label" htmlFor="typeDebit">
                                        <span className="badge bg-danger p-2 px-3 text-white">Debit (Withdraw)</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        
                        <div className="mb-4">
                            <label htmlFor="description" className="form-label fw-bold">Description</label>
                            <textarea
                                className="form-control"
                                id="description"
                                name="description"
                                value={moneyFormData.description}
                                onChange={handleMoneyFormChange}
                                placeholder="Enter transaction details"
                                rows="3"
                                required
                            ></textarea>
                            <small className="text-muted">
                                <FaInfoCircle className="me-1" />
                                Briefly describe the purpose of this transaction
                            </small>
                        </div>
                        
                        <div className="mb-4">
                            <label htmlFor="expiryDate" className="form-label fw-bold">Expiry Date</label>
                            <div className="input-group">
                                <span className="input-group-text"><FaCalendarAlt /></span>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    id="expiryDate" 
                                    name="expiryDate"
                                    value={moneyFormData.expiryDate}
                                    onChange={handleMoneyFormChange}
                                />
                            </div>
                            <small className="text-muted">
                                <FaInfoCircle className="me-1" />
                                Optional: Set an expiration date for these funds
                            </small>
                        </div>
                        
                        <div className="d-grid gap-2 mt-4">
                            <button type="submit" className="btn btn-success btn-lg">
                                <FaMoneyBillWave className="me-2" />

                                {moneyFormData.type === 'credit' ? ' Add Money' : ' Withdraw Money'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
        
    </>
  )
}

export default Wallet
